import { css, cx } from "@emotion/css"

const cn = css`
  width: var(--dot-size, 8px);
  height: var(--dot-size, 8px);
  border-radius: 50%;
  margin-right: 4px;
`

type DotProps = { color: string; className?: string }

export function Dot(props: DotProps) {
  return (
    <span
      style={{ background: props.color }}
      className={cx(cn, props.className)}
    />
  )
}
